// extracted by mini-css-extract-plugin
export var button = "InvitationConfirmationModal-module__button___V8Cjx";
export var buttonRow = "InvitationConfirmationModal-module__buttonRow___vcTdJ";
export var close = "InvitationConfirmationModal-module__close___Q2W3N";
export var description = "InvitationConfirmationModal-module__description___AE0Dz";
export var header = "InvitationConfirmationModal-module__header___iRQNm";
export var modalBody = "InvitationConfirmationModal-module__modalBody___0KGOC";
export var organizationCard = "InvitationConfirmationModal-module__organizationCard___-PSEx";
export var organizationDetails = "InvitationConfirmationModal-module__organizationDetails___oDwiW";
export var organizationImage = "InvitationConfirmationModal-module__organizationImage___SdOzl";
export var sourceCard = "InvitationConfirmationModal-module__sourceCard___HF-8l";
export var sourceName = "InvitationConfirmationModal-module__sourceName___n39fB";
export var targetCard = "InvitationConfirmationModal-module__targetCard___bIh0Y";
export var title = "InvitationConfirmationModal-module__title___CF6gA";
export var transfer = "InvitationConfirmationModal-module__transfer___QhCL3";
export var transferArrow = "InvitationConfirmationModal-module__transferArrow___EOawy";
export var transferModalBody = "InvitationConfirmationModal-module__transferModalBody___Bklga";
export var warning = "InvitationConfirmationModal-module__warning___9mfHG";
export var warningIcon = "InvitationConfirmationModal-module__warningIcon___6UKcj";